import { useEffect } from 'react';

export const useOnClickOutside = (ref, handler, ref2) => {
  useEffect(() => {
    const listener = event => {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }

      if (ref2 && ref2.current) {
        if (!ref2?.current || ref2.current.contains(event.target)) return;
      }

      handler(event);
    };
    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
};
